import React from "react";
import "./home.css";
function Home() {
  return (
    <div>
      <header aria-label="header logo">
        <div>
          <a href="https://www.studifysuccess.com" className="meet-logo">
            <img
              className="meetlogo"
              src="https://www.studifysuccess.com/images/logo.webp"
              alt="meet logo"
            />
          </a>
        </div>
      </header>
      <main className="hero-wrapper flex-hero" aria-label="banner">
        <div className="hero-img hero-img-left"></div>
        <div className="hero-img-mobile">
          {/* <img src="./assets/tablet/image-hero.png" alt="" /> */}
        </div>
        <div className="hero">
          <h1 className="h1 pb-42">
            Group Meet
            <br /> for <span className="gradient-text">Everyone</span>
          </h1>
          <p className="body-text pb-42">
            Meet makes it easy to connect with others strong face-to-face
            virtually and collaborate across any device.
          </p>
        </div>
        <div className="hero-img hero-img-right"></div>
      </main>
      <section className="divider" aria-label="second divider">
        <span className="number-bar flex"></span>
        <span className="number-one flex">01</span>
      </section>
      <section className="photo-gallery-wrapper" aria-label="photo gallery">
        <div className="gallery-grid">
          <div className="gallery-container">
            {/* <img
              src="./assets/desktop/image-woman-in-videocall.jpg"
              alt="woman during video call"
            /> */}
          </div>
          <div className="gallery-container">
            {/* <img
              src="./assets/desktop/image-women-videochatting.jpg"
              alt="weman videochatting"
            /> */}
          </div>
          <div className="gallery-container">
            {/* <img
              src="./assets/desktop/image-man-texting.jpg"
              alt="man on a video call"
            /> */}
          </div>
          <div className="gallery-container">
            {/* <img
              className="d"
              src="./assets/desktop/image-men-in-meeting.jpg"
              alt="men on a video call"
            /> */}
          </div>
        </div>
      </section>
      <section
        className="explainer-section-wrapper flex"
        aria-label="product explainer"
      >
        <span className="overline">Built for modern use</span>
        <h2 className="h2">
          Smarter meetings,
          <br />
          all in one place
        </h2>
        <p className="body-text">
          Send messages, share files, show your screen, and record your meetings
          — all in one workspace. Control who can join with invite-only team
          access, data encryption, and data export.
        </p>
      </section>
      <section className="divider-2" aria-label="divider">
        <span className="number-bar flex"></span>
        <span className="number-two flex">02</span>
      </section>
      <div className="footer-wrapper flex">
        <footer className="flex">
          <h3 className="h2">Experience more together</h3>
          <p className="body-text">
            Stay connected with reliable HD meetings and unlimited one-on-one
            and group video sessions.
          </p>
        </footer>
      </div>
    </div>
  );
}

export default Home;
